import styled from 'styled-components';
import { StyledCountBadge as BaseStyledCountBadge } from '@/modules/Conversations/components';
import { StyledCardBody } from '../Styled';

export const StyledScrollableCardBody = styled(StyledCardBody)`
  max-height: 30rem;
  overflow-y: auto;
`;

export const StyledCountBadge = styled(BaseStyledCountBadge)`
  color: ${({ theme }) => theme.token?.colorPrimary};
  background-color: ${({ theme }) => `color-mix(in srgb, ${theme.token?.colorPrimary} 5%, transparent)`};
`;
